// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import CustomerdataSchema from './customerdata-schema';
import LrrsSchema from './lrrs-schema';

const schema = {
  $id: '/deveui-uplink-schema',
  type: 'object',
  required: ['customerData', 'payload_hex', 'time'],
  properties: {
    adrbit: {
      type: 'integer',
      nullable: true,
    },
    channel: {
      type: 'string',
      nullable: true,
    },
    customerData: {
      ...CustomerdataSchema,
    },
    customerID: {
      type: 'string',
      nullable: true,
    },
    devAddr: {
      type: 'string',
      nullable: true,
    },
    devEUI: {
      type: 'string',
      nullable: true,
    },
    devLrrCnt: {
      type: 'integer',
      nullable: true,
    },
    dynamicClass: {
      type: 'string',
      nullable: true,
    },
    fcntDn: {
      type: 'integer',
      nullable: true,
    },
    fcntUp: {
      type: 'integer',
      nullable: true,
    },
    fport: {
      type: 'integer',
      nullable: true,
    },
    frequency: {
      type: 'number',
      nullable: true,
    },
    instantPER: {
      type: 'integer',
      nullable: true,
    },
    late: {
      type: 'integer',
      nullable: true,
    },
    lostUplinksAS: {
      type: 'integer',
      nullable: true,
    },
    lrcid: {
      type: 'string',
      nullable: true,
    },
    lrrESP: {
      type: 'number',
      nullable: true,
    },
    lrrid: {
      type: 'string',
      nullable: true,
    },
    lrrLAT: {
      type: 'number',
      nullable: true,
    },
    lrrLON: {
      type: 'number',
      nullable: true,
    },
    lrrRSSI: {
      type: 'integer',
      nullable: true,
    },
    lrrs: {
      ...LrrsSchema,
    },
    lrrSNR: {
      type: 'number',
      nullable: true,
    },
    meanPER: {
      type: 'number',
      nullable: true,
    },
    mic_hex: {
      type: 'string',
      nullable: true,
    },
    modelCfg: {
      type: 'string',
      nullable: true,
    },
    mtype: {
      type: 'integer',
      nullable: true,
    },
    nbTrans: {
      type: 'integer',
      nullable: true,
    },
    payload_hex: {
      type: 'string',
      pattern: '^[0-9a-fA-F]+$',
      minLength: 10,
    },
    spFact: {
      type: 'integer',
      nullable: true,
    },
    subBand: {
      type: 'string',
      nullable: true,
    },
    time: {
      type: 'string',
      format: 'date-time',
    },
    txPower: {
      type: 'integer',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
